import { fetchOfferingQueryFn } from './fetch-offering.query';
export const fetchUserSessionContextQueryFn = async props => {
  const {
    userSessionContext
  } = await fetchOfferingQueryFn(props);
  return {
    geo: (userSessionContext == null ? void 0 : userSessionContext.country) ?? undefined,
    language: (userSessionContext == null ? void 0 : userSessionContext.language) ?? undefined
  };
};
//# sourceMappingURL=fetch-user-session-context.query.js.map